import { useEffect, useState } from "react";
import TopPageTitle from "../../../components/TopPageTitle/TopPageTitle";
import * as styled from "./LessonReport.styled";
import { useSelector } from "react-redux";
import { lessonReport } from "../../../helpers/lessonReport";
import { getByGroupAndLevel } from "../../../helpers/materials/getByGroupAndLevel";
import { courseOf, fetchPlatformLessons, isPlatformLessonUrl, platformLessonUrl, wantsPlatform } from "../../../helpers/materials/platformLessons";
import { PagesWrapper } from "../../../styles/components/PagesWrapper.styled";
import DropDown from "./DropDown/DropDown";
import { LuCheck } from "react-icons/lu";
import Loader from "../../../components/Loader/Loader";
import axios from "../../../axios";
import { useNavigate, useParams } from "react-router-dom";
import { format } from "date-fns";
const lessonStatus = [
  { name: "Відбувся", value: "success" },
  { name: "Не відбувся з провини учня", value: "failed-by-student" },
  { name: "Скасовано завчасно", value: "failed" },
];
function LessonReport() {
  const { data } = useSelector((state) => state.auth);
  const navigate = useNavigate()
  const { studentId, day, time } = useParams();
  const [lessons, setLessons] = useState([]);
  const [selectedLesson, setSelectedLesson] = useState("");
  const [lessonName, setLessonName] = useState("");
  const [comment, setComment] = useState("");
  const [commentForTeacher, setCommentForTeacher] = useState("");
  const [message, setMessage] = useState("");
  const [lessonFilter, setLessonFilter] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("");
  const [statusShow, setStatusShow] = useState(false);
  const [lessonShow, setLessonShow] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const [student, setStudent] = useState(null);
  // Уроки платформи курсу учня і старі матеріали Canva — окремими вкладками, щоб учителі не плутались
  const [platformLessons, setPlatformLessons] = useState([]);
  // Звідки уроки: з картки учня (materialsSource). "platform" — лише якщо для його рівня є уроки платформи
  const [source, setSource] = useState(null);
  const [nextLesson, setNextLesson] = useState(null);



  useEffect(() => {
    if (!studentId) return;
    axios
      .get(`/student/one/${studentId}`)
      .then((res) => {
        console.log(res)
        setStudent(res.data.student);
        if (res.data.student) {
          fetchLessons(
            res.data.student.ageGroup,
            res.data.student.englishLevel,
            wantsPlatform(res.data.student)
          );
        }
      })
      .catch((err) => console.log(err));
  }, [studentId]);

  const fetchLessons = async (group, level, platformWanted) => {
    try {
      const response = await getByGroupAndLevel(group, level, data.accessType);

      const topics = response[0]?.topics || [];

      const allLessons = topics.flatMap((topic) => topic.lessons);
      setLessons(allLessons);

      // Уроки платформи (url /present/… → ДЗ учень робить у плеєрі) — лише учням на платформі
      const platform = (platformWanted ? await fetchPlatformLessons(courseOf(group, level)).catch(() => []) : []).map((lesson) => ({
        _id: lesson._id,
        number: lesson.number,
        code: lesson.code,
        name: `Lesson ${lesson.number} · ${lesson.title}${lesson.code ? ` (${lesson.code})` : ""}`,
        url: platformLessonUrl(lesson.lessonId),
      }));
      setPlatformLessons(platform);
      setSource(platform.length ? "platform" : "canva");

      // «Наступний за програмою» — лише для уроків платформи: після останнього відміченого уроку платформи цього учня
      if (platform.length) {
        const { data: history } = await axios.get(`/students/studentId/${studentId}/lessons`).catch(() => ({ data: [] }));
        const lastPlatform = (Array.isArray(history) ? history : [])
          .filter((item) => item.lessonType === "success" && isPlatformLessonUrl(item.lesson))
          .sort((a, b) => new Date(b.lessonDate) - new Date(a.lessonDate))[0];
        const lastNumber = lastPlatform ? platform.find((item) => item.url === lastPlatform.lesson)?.number : null;
        setNextLesson(lastNumber ? platform.find((item) => item.number === lastNumber + 1) || null : null);
      }
    } catch (error) {
      console.error("Error fetching lessons:", error);
    }
  };



  const handleMarkLesson = async () => {
    // Перевірки до відправки (раніше лоадер «зависав» після помилки валідації)
    const fail = (text) => {
      setMessage(text);
      setIsSuccess(false);
    };
    if (!selectedStatus) return fail("Оберіть статус уроку");
    if (selectedStatus === "success") {
      if (!selectedLesson) return fail("Оберіть урок");
      if (!comment.trim()) return fail("Напишіть відгук про урок");
    }
    setMessage("");
    setLoading(true);
    try {
      
      const salary = data.salary.find(
        (value) => value.name === student.ageGroup
      );

      await lessonReport(data._id, {
        studentId: student._id,
        teacherId: data._id,
        teacherName: data.name,
        lesson: selectedLesson,
        lessonName: lessonName,
        comment,
        salary: salary.value,
        lessonType: selectedStatus,
        commentForTeacher,
        // Лише для повідомлення в Telegram: «Lesson … / скільки всього уроків цього типу»
        lessonsLength: source === "platform" ? platformLessons.length : lessons.length,
        accessType: data.accessType,
        day, 
        time
      });
      setIsSuccess(true);
      setMessage("Урок успішно додано");
      setComment("");
      setSelectedLesson("");
      setLessons([]);
      setLessonName("");
      setSelectedStatus("");
      setCommentForTeacher("");
      setLessonShow(false);
      setStatusShow(false);
      setLoading(false);
      const dateKey = format(new Date(), "yyyy-MM-dd");
      const storage = JSON.parse(localStorage.getItem("markedLessons")) || {};
      const lessonKey = `${student._id}_${day}_${time}`;

      if (!storage[dateKey]) {
        storage[dateKey] = [];
      }
      if (!storage[dateKey].includes(lessonKey)) {
        storage[dateKey].push(lessonKey);
      }

      localStorage.setItem("markedLessons", JSON.stringify(storage));
      navigate('/teacher/general');
    } catch (error) {
      console.log(error)
      setIsSuccess(false);
      setMessage("Не вдалося відмітити урок, перевірте чи все ви заповнили");
      setLoading(false);
    }
  };
  

  if (!data || !student) return null;

  const statusName = lessonStatus.find(({ value }) => value === selectedStatus)?.name;
  const lessonList = source === "platform" ? platformLessons : lessons;

  return (
    <PagesWrapper>
      <TopPageTitle value={"Відмітка про урок"} />
      <styled.Form>
        <styled.StudentCard>
          <styled.Avatar>{student.name?.trim().charAt(0).toUpperCase()}</styled.Avatar>
          <styled.StudentInfo>
            <b>{student.name}</b>
            <small>id {student.studentId}</small>
          </styled.StudentInfo>
          <styled.LevelPill>
            {student.ageGroup} · {student.englishLevel}
            {source && ` · ${source === "platform" ? "уроки платформи" : "Canva"}`}
          </styled.LevelPill>
        </styled.StudentCard>

        <styled.Wrapper>
          <styled.Label>Статус уроку</styled.Label>
          <DropDown value={statusName} placeholder="Оберіть статус" setOpen={setStatusShow} open={statusShow} />
          {statusShow && (
            <styled.DropdownWrapper>
              {lessonStatus.map(({ name, value }) => (
                <styled.Select
                  key={value}
                  onClick={() => {
                    setSelectedStatus(value);
                    setStatusShow(false);
                  }}
                  selected={value === selectedStatus}
                >
                  <styled.Option>{name}</styled.Option>
                  {value === selectedStatus && <LuCheck size={18} />}
                </styled.Select>
              ))}
            </styled.DropdownWrapper>
          )}
        </styled.Wrapper>

        {selectedStatus !== "failed" && selectedStatus !== "failed-by-student" && (
          <>
            <styled.Wrapper>
              <styled.Label>Урок</styled.Label>
              <DropDown
                value={lessonName}
                placeholder={source ? "Оберіть урок" : "Завантаження уроків…"}
                setOpen={setLessonShow}
                open={lessonShow}
                disabled={!source}
              />
              {lessonShow && source && (
                <styled.DropdownWrapper>
                  {source === "platform" && nextLesson && (
                    <styled.Next
                      type="button"
                      onClick={() => {
                        setSelectedLesson(nextLesson.url);
                        setLessonName(nextLesson.name);
                        setLessonShow(false);
                      }}
                    >
                      <span>Наступний за програмою</span>
                      <b>{nextLesson.name}</b>
                    </styled.Next>
                  )}
                  <styled.Input
                    type="text"
                    placeholder="Пошук уроку"
                    value={lessonFilter}
                    onChange={(e) => setLessonFilter(e.target.value)}
                  />
                  {lessonList
                    .filter((lesson) => lesson.name.toLowerCase().includes(lessonFilter.toLowerCase()))
                    .map((lesson) => (
                      <styled.Select
                        onClick={() => {
                          setSelectedLesson(lesson.url);
                          setLessonName(lesson.name);
                          setLessonShow(false);
                        }}
                        selected={lesson.url === selectedLesson}
                        key={lesson._id}
                      >
                        <styled.Option>{lesson.name}</styled.Option>
                        {lesson.url === selectedLesson && <LuCheck size={18} />}
                      </styled.Select>
                    ))}
                  {lessonList.length === 0 && <styled.Option>Немає уроків для цього рівня</styled.Option>}
                </styled.DropdownWrapper>
              )}
            </styled.Wrapper>

            <styled.Wrapper>
              <styled.Label>Відгук про урок (бачить учень)</styled.Label>
              <styled.TextArea
                placeholder="Що вийшло добре, над чим попрацювати"
                value={comment}
                onChange={(e) => setComment(e.target.value)}
              />
            </styled.Wrapper>
            <styled.Wrapper>
              <styled.Label>Помітка для себе</styled.Label>
              <styled.TextArea
                placeholder="Бачите лише ви"
                value={commentForTeacher}
                onChange={(e) => setCommentForTeacher(e.target.value)}
              />
            </styled.Wrapper>
          </>
        )}

        {selectedStatus === "failed" ? (
          <styled.Message isSuccess>У такому випадку відмітка уроку не є необхідною</styled.Message>
        ) : !loading ? (
          <styled.Button type="button" onClick={handleMarkLesson}>
            Відмітити урок
          </styled.Button>
        ) : (
          <styled.LoaderWrapper>
            <Loader customWidth={150} />
          </styled.LoaderWrapper>
        )}
        {message && <styled.Message isSuccess={isSuccess}>{message}</styled.Message>}
      </styled.Form>
    </PagesWrapper>
  );
}

export default LessonReport;
